module.exports = __webpack_public_path__ + "static/media/1001800DO.4d7d0648.jpg";